jQuery('button#AddToCart--product-template').prop("disabled", true);


var breakpoints = {
  "xsmall": 320,
  "small": 576,
  "medium": 768,
  "large": 992,
  "xlarge": 1200,
  "xxlarge": 1400,
  "full": 1600,
};

(function($) {
  $(document).ready(function(e){
    handleBannerHeight();
  });
  $(window).on('load',function(e){
    handleBannerHeight();
  });
  $(window).on('resize orientationchange', function(e){
    handleBannerHeight();
  });
  function handleBannerHeight(){
    if( $(window).width() >= breakpoints.medium ){
      var header_height = $("header").outerHeight();
      header_height += $("#shopify-section-announcement-bar").outerHeight();
      //$(".template-index #MainContent .slider").css("height", "calc(100vh - "+header_height+"px)");
      $(".template-index #MainContent .slider").attr("style", "height: calc(100vh - "+header_height+"px) !important");
    } else {
      //$(".template-index #MainContent .slider").css("height", "");
      $(".template-index #MainContent .slider").attr("style", "");
    }
  }
})(jQuery);
